var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"my-4 border"},[_c('v-flex',{staticClass:"pa-2"},[_c('v-text-field',{staticClass:"ucFirst body-2",attrs:{"aria-label":_vm.formattedAriaLabel(
                _vm.metadata[("description" + (this.upperLocale))],
                _vm.required
            ),"label":_vm.formattedLabel(
                _vm.metadata[("description" + (this.upperLocale))],
                _vm.required
            ),"outline":_vm.outline,"append-icon":_vm.appendIcon,"value":_vm.value.trim(),"rules":[
                !_vm.required || _vm.requiredField(),
                function (v) { return !v || _vm.getFormRule('name')(v); }
            ],"data-testid":"covid-screening-outbreak-number-input","data-meta-id":_vm.metadata.id,"id":_vm.metadata.name},on:{"change":_vm.emitValue}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }